/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Перетягніть, щоб змінити розмір панелі',
  command_intelligence_close_aria: 'Закрити помічника',
  command_intelligence_send_aria: 'Надіслати повідомлення',
  command_intelligence_stop_aria: 'Зупинити відповідь',
  command_intelligence_composer_input_aria: 'Повідомлення для Command Intelligence',
  command_intelligence_drawer_more_options: 'Більше параметрів',
  command_intelligence_dock_position: 'Позиція закріплення',
  command_intelligence_dock_left: 'Ліворуч',
  command_intelligence_dock_right: 'Праворуч',
  command_intelligence_dock_top: 'Зверху',
  command_intelligence_dock_bottom: 'Знизу',
  command_intelligence_panel_layout: 'Макет панелі',
  command_intelligence_panel_layout_overlap: 'Накладати на вміст',
  command_intelligence_panel_layout_push: 'Зсувати вміст',
  command_intelligence_panel_auto_hide_overlap: 'Автоматично приховувати при кліку ззовні',
  command_intelligence_session_reset: 'Скинути розмову',
  command_intelligence_try_one_of_these: 'Спробуйте одне з цих',
  command_intelligence_attach_hint: 'Додайте елементи контексту, щоб почати ставити запитання.',
  command_intelligence_welcome_subhead: 'Поставте запитання, щоб почати.',
  command_intelligence_attach_modal_title: 'Додати контекст',
  command_intelligence_attach_modal_subtitle: 'Виберіть з елементів у цьому поданні. Уже додані елементи затемнені.',
  command_intelligence_attach_modal_search_placeholder: 'Пошук…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# елемент доступний} few {# елементи доступні} many {# елементів доступно} other {# елемента доступно}} · вибрано {selected}',
  command_intelligence_attach_modal_empty: 'Немає доступних елементів для додавання',
  command_intelligence_attach_modal_no_results: 'Жоден елемент не відповідає пошуку',
  command_intelligence_context_bar_attached_section: 'Додано ({count})',
  command_intelligence_context_bar_clear_attached: 'Очистити',
  command_intelligence_context_bar_add: 'Додати контекст',
  command_intelligence_placeholder_ready: 'Поставте запитання…',
  command_intelligence_placeholder_attach: 'Додайте контекст, щоб поставити запитання…',
  command_intelligence_composer_submit_hint: 'Enter — надіслати · Shift+Enter — новий рядок',
  command_intelligence_composer_stop_hint: 'Зупинити · чернетка наступного повідомлення під час очікування',
  command_intelligence_response_stopped: 'Відповідь зупинено',
  command_intelligence_generation_in_progress: 'Обробка вашого запитання',
  command_intelligence_generation_trace_title: 'Виконані кроки',
  command_intelligence_generation_trace_toggle: 'Показати кроки',
  command_intelligence_generation_trace_summary: 'Виконано {completed} з {total} кроків',
  command_intelligence_generation_trace_summary_generic: 'Кроки генерації',
  command_intelligence_generation_tool_count:
    '{count, plural, one {# інструмент} few {# інструменти} many {# інструментів} other {# інструмента}}',
  command_intelligence_generation_turn_label: 'Хід {turn} з {total}',
  command_intelligence_generation_turn_completed: 'Завершено хід {turn} з {total}',
  command_intelligence_generation_turn_completed_elapsed: 'Завершено хід {turn} з {total} (минуло {seconds} с)',
  command_intelligence_generation_turn_completed_with_tools: 'Завершено хід {turn} з {total} — використано {tools}',
  command_intelligence_generation_tools_used: 'Використано {tools}',
  command_intelligence_reasoning_thinking: 'Думаю…',
  command_intelligence_reasoning_thought_for_seconds: 'Думав {seconds} секунд',
  command_intelligence_reasoning_waiting: 'Обробка вашого запитання…',
  command_intelligence_attach_modal_done: 'Готово',
  command_intelligence_attach_modal_attached_badge: 'додано',
  command_intelligence_attach_modal_attach: 'Додати',
  command_intelligence_attach_modal_attach_count: 'Додати ({count})',
  command_intelligence_attach_modal_close_aria: 'Закрити вибір',
  command_intelligence_session_limit_context: 'Досягнуто ліміт контексту. Скиньте розмову, щоб продовжити.',
  command_intelligence_session_limit_prompt: 'Досягнуто ліміт повідомлень. Скиньте розмову, щоб продовжити.',
  command_intelligence_suggested_followups: 'Запропоновані уточнення',
  command_intelligence_credit_warning_line: 'Використано {pct}% місячних кредитів ШІ для {scope}',
  command_intelligence_tooltip_prompts: '{count} з {max} повідомлень ({pct}%)',
  command_intelligence_tooltip_context: '{used} з {max} токенів контексту ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Використання контексту з’являється після першої відповіді',
  command_intelligence_credits_loading: 'Завантаження кредитів…',
  command_intelligence_credits_unavailable: 'Кредити недоступні',
  command_intelligence_credits_tooltip: 'Місячні кредити ШІ за {monthKey}',
  command_intelligence_credits_tooltip_short: 'Місячні кредити ШІ',
  command_intelligence_credits_scope_profile: 'Профіль',
  command_intelligence_credits_scope_entity: 'Сутність',
  command_intelligence_credits_used_of_cap: '{used} з {cap} кредитів',
  command_intelligence_credits_used_no_cap: 'Використано {used} кредитів',
  command_intelligence_credits_monthly_title: 'Місячні кредити ШІ',
  command_intelligence_compare_aria: 'Порівняти агентів',
  command_intelligence_compare_tooltip: 'Запустити те саме запитання для кількох профілів агентів',
  command_intelligence_compare_cancelled: 'Порівняння скасовано',
  command_intelligence_compare_branch_failed: 'Гілка порівняння не вдалася',
  command_intelligence_compare_title: 'Порівняння агентів',
  command_intelligence_compare_stats: '{durationMs} мс · {model} · {inTok} вх. / {outTok} вих. · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Гарна відповідь',
  command_intelligence_feedback_bad_response: 'Погана відповідь',
  command_intelligence_feedback_dialog_title: 'Надіслати відгук',
  command_intelligence_feedback_dialog_body:
    'Допоможіть нам покращитися, надіславши відгук про цю відповідь. Ваш відгук буде надіслано нашій операційній команді.',
  command_intelligence_feedback_response_label: 'Відповідь',
  command_intelligence_feedback_input_label: 'Ваш відгук (необов’язково)',
  command_intelligence_feedback_input_placeholder: 'Що було неправильним або малокорисним у цій відповіді?',
  command_intelligence_feedback_submit: 'Надіслати відгук',
  command_intelligence_feedback_submit_error: 'Не вдалося надіслати відгук. Спробуйте ще раз.',
  command_intelligence_feedback_question_understanding: 'Чи зрозумів агент, чого ви хотіли?',
  command_intelligence_feedback_question_readability: 'Чи була відповідь легкою для читання та використання?',
  command_intelligence_feedback_section_understanding: 'Розуміння',
  command_intelligence_feedback_section_readability: 'Читабельність',
  command_intelligence_feedback_choice_none: 'Немає',
  command_intelligence_feedback_choice_misunderstood_task: 'Неправильно зрозумів завдання',
  command_intelligence_feedback_choice_ignored_constraint: 'Ігнорував обмеження',
  command_intelligence_feedback_choice_wrong_scope: 'Неправильна область',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Візуально важко читати',
  command_intelligence_feedback_choice_wrote_too_much: 'Занадто багато тексту',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Пояснення ненадійне',
  command_intelligence_copy_aria: 'Копіювати в буфер обміну',
  command_intelligence_error_missing_invoke_permission:
    'У вас немає дозволу на використання Command Intelligence для цього агента. Попросіть адміністратора надати необхідні дозволи Intelligence (наприклад, analyst).',
  command_intelligence_access_denied_title: 'Потрібен доступ',
  command_intelligence_error_session_expired: 'Ваш сеанс завершився. Оновіть сторінку та увійдіть знову.',
};
